import { ImportComplementOrigin } from './WorkOrderImports.enum';

export const importTypesOptions = [
  { name: 'SOMA', origin: ImportComplementOrigin.Soma },
  { name: 'Cilia', origin: ImportComplementOrigin.Cilia },
  { name: 'AudatexWeb', origin: ImportComplementOrigin.AudatexWeb },
  { name: 'I360', origin: ImportComplementOrigin.I360 },
  { name: 'JSON', origin: ImportComplementOrigin.JsonImport },
];
